<div id="app-container">
  <nav
    (click)="lockScreen()"
    class="navbar custom-sticky-header"
    [class.bg-body-tertiary]="currentTheme !== 'dark'"
  >
    <div
      class="d-flex justify-content-between gap-2 align-items-center w-100 px-2"
    >
      <div class="d-flex align-items-center">
        @if (
          isSubscriptionActive &&
          (isAdmin ||
            (isOnlyGuardAndDispatcher && !showWelfareCheck?.welfare_check_id))
        ) {
          @if (isAppOnline) {
            @if (routeInsideRoot && !showBackBtn) {
              <div
                id="sidebar-menu"
                class="me-1 me-lg-0"
                (click)="toggleSideBarMenu()"
              >
                <i
                  class="fa-solid fa-bars-staggered ps-2"
                  [ngClass]="largeView ? 'fs-4' : 'fa-2x pe-2'"
                ></i>
              </div>
            } @else {
              <div (click)="goBack()" class="me-1 me-lg-0">
                <i
                  class="fas fa-angle-left md-font-size ps-2"
                  [ngClass]="largeView ? 'fs-4' : 'fa-2x pe-2'"
                ></i>
              </div>
            }
          } @else {
            @if (internetConnectionAvailable && offlineMode) {
              <!--server is down and internet is available-->
              <div
                (click)="navigateHome(true); navbarToggled = false"
                class="me-1 me-lg-0"
              >
                <i
                  class="fa-solid fa-rotate-right md-font-size ps-2"
                  [ngClass]="largeView ? 'fs-4' : 'fa-2x pe-2'"
                ></i>
              </div>
            } @else if (isHomeComponent) {
              <!--is in home page-->
              @if (!isPhoneIOS) {
                <div
                  (click)="navigateHome(true); navbarToggled = false"
                  class="me-1 me-lg-0"
                >
                  <i
                    class="fa-solid fa-rotate-right md-font-size ps-2"
                    [ngClass]="largeView ? 'fs-4' : 'fa-2x pe-2'"
                  ></i>
                </div>
              }
            } @else {
              <div
                (click)="navigateHome(); navbarToggled = false"
                class="me-1 me-lg-0"
              >
                <i
                  class="fa-solid fa-house md-font-size"
                  [ngClass]="largeView ? 'fs-4' : 'fa-2x pe-2'"
                ></i>
              </div>
            }
          }
        }

        <!-- Logo -->

        <div
          id="gt-logo-home"
          (click)="guardTrackerIconClick()"
          [ngClass]="
            ['/', '/dashboard'].includes(currentRoute)
              ? 'ms-lg-3'
              : 'ms-lg-4 gt-logo-home'
          "
          role="button"
        >
          <img
            src="../../../assets/images/Guard_Tracker-Lateral_Long_{{
              currentTheme
            }}.avif"
            alt="Guard Tracker"
            id="gtLogo"
            height="auto"
            [width]="screenWidth - 275"
          />
        </div>
        <div class="d-none d-lg-block">
          <div class="d-flex gap-2 ms-1 px-2 overflow-auto flex-nowrap">
            @if (!["/", "/dashboard"].includes(currentRoute)) {
              <div
                class="d-flex gap-1 px-2 desktop-top-menu-items"
                (click)="navigateHome()"
                role="button"
              >
                <span> <i class="fa-solid fa-house fs-6"></i> </span
                ><span> HOME </span>
              </div>
            }
            <!-- <div
              class="d-flex gap-1 px-2 desktop-top-menu-items"
              routerLink="/schedule"
              role="button"
            >
              <span> <i class="fa-solid fa-calendar-days fs-6"></i> </span
              ><span> SCHEDULE </span>
            </div> -->

            @for (menu of sideBarMenuItems; track menu) {
              @if (
                ["/schedule", "/jobs", "/roster", "/reports"].includes(
                  menu?.link
                )
              ) {
                <div
                  class="d-flex gap-1 px-2 desktop-top-menu-items align-items-center"
                  (click)="redirectToPage(menu.link)"
                  role="button"
                >
                  @if (menu?.icon?.includes("fa")) {
                    <span><i [ngClass]="menu.icon" class="fs-6"></i></span>
                  }

                  <span>{{ menu.title }}</span>
                </div>
              }
            }
            <!-- @for (menu of lastUsedRoutes; track menu) {
              @if (menu?.icon?.includes("fa")) {
                <div
                  class="d-flex gap-1 px-2 desktop-top-menu-items opacity-75"
                  (click)="redirectToPage(menu.link)"
                  role="button"
                >
                  @if (menu?.icon?.includes("fa")) {
                    <span><i [ngClass]="menu.icon" class="fs-6"></i></span>
                  }

                  <span>{{ menu.title }}</span>
                </div>
              }
            } -->
          </div>
        </div>
      </div>

      <div class="d-flex gap-3 align-items-center flex-wrap">
        <!-- this button will show up only when a super user access as a normal user. This is like bypassing the authentication-->
        @if (isSuperUserAccess) {
          <div
            class="fixed-top"
            style="left: 70px; top: 10px; width: fit-content"
          >
            <button
              class="btn btn-outline-danger btn-sm bg-white"
              (click)="exitUser()"
            >
              Exit User
            </button>
          </div>
        }
        @if (
          showWelfareCheck?.welfare_check_id &&
          isSubscriptionActive &&
          largeView
        ) {
          <button
            class="btn btn-danger btn-sm"
            (click)="welfareCheckIn(missedEventReasonTemplateRef)"
          >
            Send Welfare Check
          </button>
        }
        @if (newSupportUpdate && isAppOnline) {
          <span [routerLink]="['/support']">
            <i class="fa-solid fa-envelope fa-2x"></i>
          </span>
        }
        @if (
          largeView &&
          isAppOnline &&
          permissionErrorStatus?.message &&
          permissionErrorStatus?.icon === "alert-triangle"
        ) {
          <div
            id="customTooltipBtn"
            class="custom-tooltip"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            [attr.data-bs-original-title]="permissionErrorStatus?.message"
            [gtappGtTooltip]="permissionErrorStatus?.status"
          >
            <i class="fa fa-exclamation-triangle text-danger fa-2x"></i>
          </div>
        }
        @if (isDeveloperMode && isNativeApp) {
          <span
            (click)="navigateHome(true); navbarToggled = false"
            class="z-index-1001"
          >
            <i class="fa-solid fa-rotate-right md-font-size text-danger"></i>
          </span>
        }
        @if (currentRoute !== "/message" && showChatMessageIcon) {
          <div
            [routerLink]="['/message']"
            (click)="unReadMessageCount = 0; navbarToggled = false"
            class="position-relative d-inline-block"
          >
            @if (unReadMessageCount || (notificationCount && isAppOnline)) {
              <span>
                <i
                  class="fa-solid fa-comments fs-5 chat-icon-notification border px-2 border-2 py-1 rounded shadow hover"
                  title="Chat"
                ></i
              ></span>
              <span
                class="badge bg-danger position-absolute top-0 start-50 translate-middle"
              >
                {{ unReadMessageCount + notificationCount }}
              </span>
            } @else {
              <span
                class="border px-2 border-2 pt-3 pb-1 rounded shadow hover"
                id="chatButton"
              >
                <i class="fa-solid fa-comments fs-3" title="Chat"></i
              ></span>
            }
          </div>
        }

        @if (isAppOnline && isPreviousSubscribed) {
          <div
            id="globalFeedbackbtn"
            (click)="
              openSupportQueryCreateTemplate(supportQueryCreateTemplateRef)
            "
          >
            <i
              class="fa-regular fa-circle-question feedback-icon"
              title="Help"
            ></i>
          </div>
        }
        @if (!isSubscriptionActive) {
          <button
            class="btn text-secondary"
            type="button"
            (click)="cancelSubscription()"
          >
            Cancel
          </button>
        }
      </div>
    </div>

    <!-- <div class="d-none d-lg-block pt-2">
      <div class="d-flex gap-2 ms-2 mw-100 overflow-auto">
        @for (
          menu of isAdmin
            ? sideBarMenuItems?.concat(settingItems)
            : sideBarMenuItems;
          track menu
        ) {
          <div
            class="d-flex gap-1 p-2 desktop-top-menu-items"
            (click)="redirectToPage(menu.link)"
            role="button"
          >
            @if (menu?.icon?.includes("fa")) {
              <span><i [ngClass]="menu.icon" class="fs-6"></i></span>
            }

            <span>{{ menu.title }}</span>
          </div>
        }
      </div>
    </div> -->
    @if (isSubscriptionActive && !largeView) {
      <div
        class="d-md-none d-flex small justify-content-center w-100"
        id="statusInfo"
      >
        <!-- status icon to show whether there is background sync by service worker and user offline/online status-->

        <div
          id="customTooltipBtn"
          class="custom-tooltip"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          [attr.data-bs-original-title]="
            permissionErrorStatus?.message
              ? permissionErrorStatus?.message
              : isInBackgroundSync
                ? 'Synchronizing Data'
                : isAppOnline
                  ? ''
                  : 'Unable to reach server. Operating in offline mode.'
          "
          [gtappGtTooltip]="permissionErrorStatus?.status"
        >
          @if (permissionErrorStatus?.icon === "alert-triangle") {
            <span>
              <i
                class="fa fa-exclamation-triangle text-danger md-font-size"
              ></i>
            </span>
          }

          @if (!permissionErrorStatus?.icon && isInBackgroundSync) {
            <span>
              <i
                class="fa fa-exclamation-triangle text-warning md-font-size"
              ></i>
            </span>
          }

          @if (!permissionErrorStatus?.icon && !isAppOnline) {
            @if (internetConnectionAvailable) {
              <span> <i class="fa fa-wifi text-warning md-font-size"></i></span>
            } @else {
              <span class="small-font text-danger">
                [Working in Offline Mode]
              </span>
            }
          }
        </div>
      </div>
    }
  </nav>

  <div (click)="lockScreen()" id="wrapper" #sideBarMenu>
    <!-- Sidebar -->
    @if (
      isAppOnline &&
      isSubscriptionActive &&
      navbarToggled &&
      (isAdmin ||
        (isOnlyGuardAndDispatcher && !showWelfareCheck?.welfare_check_id))
    ) {
      <div
        class="border-right shadow"
        id="sidebar-wrapper"
        [ngClass]="navbarToggled ? 'hide' : 'show'"
      >
        <!-- Normal menu items -->
        <div class="list-group list-group-flush">
          @if (!showManageMenu) {
            @for (menu of sideBarMenuItems; track menu) {
              <div
                class="list-group-item list-group-item-action"
                (click)="redirectToPage(menu.link)"
              >
                <div class="menu-item" [id]="guideIdMapping?.[menu.link]">
                  @if (menu.icon) {
                    <span><i [ngClass]="menu.icon" class="me-2 fs-6"></i></span>
                  }

                  <span>{{ menu.title }}</span>
                </div>
              </div>
            }
          }
          <div
            class="submenu-container"
            [ngClass]="{ 'submenu-visible': showManageMenu }"
          >
            @for (subMenu of settingItems; track subMenu) {
              <div
                class="list-group-item list-group-item-action"
                (click)="redirectToPage(subMenu.link)"
              >
                <div class="menu-item" [id]="subMenu?.id">
                  <span>{{ subMenu.title }}</span>
                </div>
              </div>
            }
          </div>
        </div>
        <!-- User Profile and clock in Section -->
        <div class="sidebar-footer">
          @if (!isNativeApp) {
            <div class="app-badge-container ps-2 d-none">
              @if (largeView || isPhoneIOS) {
                <div
                  role="button"
                  class="badge-link apple-badge"
                  (click)="onBadgeClick('apple', nativeAppDownloadTemplate)"
                  aria-label="Download on the App Store"
                >
                  <img
                    [src]="
                      currentTheme === 'dark'
                        ? 'assets/native-app-logo/app-store-light.svg'
                        : 'assets/native-app-logo/app-store-dark.svg'
                    "
                    alt="Download on the App Store"
                  />
                </div>
              }

              @if (largeView || !isPhoneIOS) {
                <div
                  role="button"
                  class="badge-link google-badge"
                  (click)="onBadgeClick('google', nativeAppDownloadTemplate)"
                  aria-label="Get it on Google Play"
                >
                  <img
                    src="assets/native-app-logo/google-play.png"
                    alt="Get it on Google Play"
                  />
                </div>
              }
            </div>
          }
          <!-- Install App -->
          @if (!isPWAInstalled && deferredPWAInstallPrompt) {
            <div class="p-2 d-sm-block d-md-none">
              <button
                class="btn btn-lg btn-success w-100"
                (click)="installPWAApp()"
              >
                Install App
              </button>
            </div>
          }

          <!-- Flex container for Sign Out, theme switcher, settings and sub menu -->
          <div
            class="d-flex justify-content-between align-items-center w-100 ps-2 pb-lg-4"
          >
            <div class="d-lg-block ms-3">
              <span
                (click)="onUserSignOut()"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Sign Out"
              >
                <button class="btn btn-sm btn-outline-secondary">
                  Sign Out
                </button>
              </span>
            </div>

            <!-- Theme Switcher -->
            <div
              id="theme-icon"
              class="theme-switcher mx-2 cursor-pointer"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Toggle Theme"
              (click)="switchTheme()"
            >
              @if (currentTheme === "dark") {
                <span><i class="bi bi-sun-fill fs-5"></i></span>
              } @else {
                <span><i class="bi bi-moon-stars-fill fs-5"></i></span>
              }
            </div>

            <!-- Settings Cog -->
            @if (isAdmin) {
              <div
                id="settings-icon"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Settings"
                (click)="toggleManageMenu()"
                [ngStyle]="{
                  transform: showManageMenu ? 'rotate(90deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease',
                }"
              >
                <i class="fa-solid fa-cog fs-5"></i>
              </div>
            }

            <!-- Account Switch -->
            @if (hasMultipleAccountsLinked && isAppOnline) {
              <div
                id="switchAccountIcon"
                role="button"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Switch Account"
                (click)="openSwitchAccountTemplate()"
              >
                <i class="fa-solid fa-arrow-right-arrow-left fs-5"></i>
              </div>
            }

            <!-- User Profile Icon -->
            <!-- tabindex="0" makes the div focusable -->
            <div
              id="user-menu"
              tabindex="0"
              (focusout)="toggleUserProfileMenu(true)"
              (click)="toggleUserProfileMenu()"
              class="sidebar-user-icon"
              [attr.data-letters]="loggedInUser?.initialName"
            ></div>
          </div>

          <!-- User Profile Menu -->
          <div
            class="dropdown-menu shadow user-dropdown-position mb-2"
            [class.show]="showUserDropdown"
          >
            @for (subMenuItem of userMenu; track $index) {
              <div
                class="dropdown-item user-menu-content"
                (click)="redirectToPage(subMenuItem?.link)"
              >
                {{ subMenuItem.title }}
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- /#sidebar-wrapper -->

    <!-- Page Content -->
    <div
      id="page-content-wrapper"
      (click)="handleWrapperClick($event)"
      [ngStyle]="isSubscriptionActive ? {} : { 'margin-left': '0px' }"
    >
      <div class="container-fluid pt-1 px-1 p-lg-2">
        @if (isInGracePeriod) {
          <!--not active subscription remaining but is in grace period-->
          <div
            class="alert alert-danger text-center"
            [routerLink]="isSubscriberAdmin ? '/subscription' : ''"
          >
            <span class="cursor-pointer"> Payment Due</span>
          </div>
        }
        @if (!isSubscriptionActive) {
          @if (isSubscriberAdmin) {
            <div class="alert alert-warning text-center">
              You do not currently have a valid subscription, please select a
              plan to continue
            </div>
          } @else {
            <div
              class="alert alert-warning text-center"
              [routerLink]="isSubscriberAdmin ? '/subscription' : ''"
            >
              Invalid Subscription
            </div>
          }
        }
        @if (minSupportVersionDevice?.id) {
          <div class="alert alert-warning text-center">
            Outdated browser detected, please update your web browser for the
            best experience.
          </div>
        }
        <!--welfare check button STARTS-->
        @if (welfareCheckOfflineAlert?.time) {
          <div class="alert alert-danger text-center">
            A Welfare Check is due soon, but your device is unable to connect to
            the server.
          </div>
        }
        @if (appNewVersionAvailable) {
          <div class="my-1 d-flex gap-2 justify-content-end">
            @if (appNewVersionAvailable) {
              <!-- new update available notification-->

              <button
                class="btn btn-success btn-sm"
                (click)="updateGuardTrackerApp()"
              >
                Update App
              </button>
            }
          </div>
        }

        @if (
          showWelfareCheck?.welfare_check_id &&
          isSubscriptionActive &&
          !largeView
        ) {
          <div class="text-center px-2 mt-1 mb-4">
            <button
              class="btn btn-primary btn-xl w-100"
              (click)="welfareCheckIn(missedEventReasonTemplateRef)"
            >
              Send Welfare Check
            </button>
          </div>
        }

        @if (sosAlertCount > 0 && (isAdmin || isDispatchUser) && isAppOnline) {
          <div class="d-flex m-2 gap-1">
            <div class="flex-grow-1">
              <button
                class="w-100 btn btn-lg rounded-1 fw-semibold fs-5 text-capitalize sos-blink"
                (click)="showSOSAlerts()"
              >
                SOS Alerts
              </button>
            </div>
            @if (isAlertActive) {
              <button class="btn btn-dark btn-lg" (click)="stopAlert()">
                <i class="fa-solid fa-volume-xmark"></i>
              </button>
            }
          </div>
        }

        @if (
          isSuperUser ||
          isSubscriberAdmin ||
          allowedPaths ||
          (isSubscriptionActive && !showWelfareCheck?.welfare_check_id)
        ) {
          <div>
            <router-outlet></router-outlet>
          </div>
        }
        @if (windowScrolled && currentRoute !== "/message") {
          <div
            class="scroll-up"
            (click)="scrollToTop(); $event.stopImmediatePropagation()"
          >
            <i class="fa-solid fa-angles-up fa-4x text-secondary"></i>
          </div>
        }
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
</div>

<!-- missed event reason providing template-->
<ng-template
  #missedEventReasonTemplateRef
  let-missedEventReasonTemplateRef="dialogRef"
>
  <div class="dialog-box card p-2">
    <div class="card-header">
      Missed Welfare Check
      <span class="float-end" (click)="missedEventReasonTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="row row-cols-1">
      <div class="text-center mb-1">
        {{ showWelfareCheck?.welfare_check_missed_at | date: "d MMM" }}
        <span class="fw-bold">{{
          showWelfareCheck?.welfare_check_missed_at | date: "HH:mm"
        }}</span>
      </div>
      <div class="mb-2">
        <textarea
          class="form-control"
          type="text"
          placeholder="Reason for missing welfare check"
          [(ngModel)]="welfareCheckMissedReason"
          rows="3"
        ></textarea>
      </div>
      <div class="mb-3">
        <button
          type="button"
          class="btn btn-primary btn-lg w-100"
          [disabled]="!welfareCheckMissedReason"
          (click)="missedEventReasonTemplateRef.close(true)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #supportQueryCreateTemplateRef let-feedbackRef="dialogRef">
  <div class="card dialog-box p-1 pb-2">
    <div class="card-header">
      Help

      <span
        class="float-end"
        (click)="
          feedbackRef.close('close'); showHideDraggableFeedbackBtn(false)
        "
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="px-3 mb-4">
      <div id="links" class="d-flex flex-column gap-4">
        @if (showGettingStartedGuideOption && isAdmin) {
          <div
            class="fw-semibold nav-link text-primary hover px-1"
            (click)="
              feedbackRef.close('close');
              showHideDraggableFeedbackBtn(false);
              restartGetStarted()
            "
          >
            Getting Started
          </div>
        }

        <div
          class="fw-semibold nav-link text-primary hover px-1"
          (click)="
            feedbackRef.close('close');
            showHideDraggableFeedbackBtn(false);
            restartTutorial()
          "
        >
          Replay Tutorials
        </div>
        @if (iosSafariBrowser && !isNativeApp) {
          <div
            class="fw-semibold nav-link text-primary hover px-1"
            (click)="
              feedbackRef.close('close');
              showHideDraggableFeedbackBtn(false);
              openScreenShotComponent()
            "
          >
            Fix / Allow Permissions
          </div>
        }
      </div>
    </div>

    <div class="p-1 mb-3">
      <form [formGroup]="feedbackForm" class="row-cols-1 gy-2">
        <div class="col form-group input-group">
          <textarea
            class="form-control"
            cols="32"
            rows="5"
            wrap="hard"
            maxlength="340"
            placeholder="Need help or have feedback? Please tell us how we can help."
            formControlName="feedback"
            id="updateCommentBox"
          ></textarea>
          @if (feedbackForm.value.feedback) {
            <span
              class="input-group-text"
              (click)="clearAndFocusTextBox('updateCommentBox')"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      </form>
    </div>

    <!-- <div class="p-1 mb-2 small">
              @if(feedbackAttachment?.fileUrl){
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <img src="{{ feedbackAttachment?.fileUrl }}" width="200" />
                  </div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      (click)="feedbackAttachment = {}"
                      >
                      Delete Photo
                    </button>
                  </div>
                </div>

                }@else {
                <div>
                  <button
                    class="btn btn-outline-primary btn-sm"
                    (click)="attachImageToQuery()"
                    >
                    Add Photo (Optional)
                  </button>
                  <span class="small text-secondary">
                    Add an image so that we can understand you better</span
                    >
                  </div>
                }
              </div> -->

    <div class="d-flex gap-1 mb-4">
      <div id="buttons" class="d-flex gap-2 mx-auto">
        <button
          (click)="
            feedbackRef.close('close'); showHideDraggableFeedbackBtn(false)
          "
          class="btn btn-secondary btn-md w-100 h-100"
        >
          Cancel
        </button>

        @if (existingSupportQueries) {
          <button
            class="btn btn-outline-success btn-md w-100 h-100"
            [routerLink]="['/support']"
            (click)="
              feedbackRef.close('close'); showHideDraggableFeedbackBtn(false)
            "
          >
            Support Inquiries
          </button>
        }

        <button
          (click)="
            addfeedback();
            feedbackRef.close();
            showHideDraggableFeedbackBtn(false)
          "
          class="btn btn-primary btn-md w-100 h-100"
          [disabled]="!feedbackForm.valid"
        >
          Submit
        </button>
      </div>
    </div>
    <div
      id="debugTools"
      class="d-flex flex-wrap justify-content-between align-items-center mb-1 flex-lg-row flex-column"
    >
      <div id="info" class="px-3 py-0 small text-secondary">
        <div>
          {{ userCurrentDeviceDetail?.time | customDate: "d MMM y HH:mm" }}
          {{ userCurrentDeviceDetail?.timeZone }}
          @if (userCurrentDeviceDetail?.gps?.lat) {
            <span>
              @if (userCurrentDeviceDetail?.os?.toLowerCase() === "ios") {
                <a
                  class="text-decoration-none text-secondary hover"
                  [href]="
                    'https://maps.apple.com?q=' +
                    userCurrentDeviceDetail?.gps?.lat +
                    ',' +
                    userCurrentDeviceDetail?.gps?.lon
                  "
                  target="_blank"
                >
                  {{ userCurrentDeviceDetail?.gps?.lat?.toFixed(5) }},
                  {{ userCurrentDeviceDetail?.gps?.lon?.toFixed(5) }}
                </a>
              } @else {
                <a
                  class="text-decoration-none text-secondary hover"
                  [href]="
                    'https://www.google.com/maps/search/?api=1&query=' +
                    userCurrentDeviceDetail?.gps?.lat +
                    ',' +
                    userCurrentDeviceDetail?.gps?.lon
                  "
                  target="_blank"
                >
                  {{ userCurrentDeviceDetail?.gps?.lat?.toFixed(5) }},
                  {{ userCurrentDeviceDetail?.gps?.lon?.toFixed(5) }}
                </a>
              }
            </span>
          }
        </div>
        <div>
          {{ userCurrentDeviceDetail?.deviceType }}
          {{ userCurrentDeviceDetail?.device }}
          {{ userCurrentDeviceDetail?.os }}
          {{ userCurrentDeviceDetail?.os_version }}
          {{ userCurrentDeviceDetail?.browser }}
          {{ userCurrentDeviceDetail?.browser_version }}
        </div>
      </div>

      <div
        role="button"
        class="border py-1 px-3 rounded border-4 text-center mb-lg-0 my-2 hover"
        (click)="
          feedbackRef.close('close');
          showHideDraggableFeedbackBtn(false);
          clearAllDataAndReload()
        "
      >
        Clear Cache
      </div>
    </div>
  </div>
</ng-template>

<ng-template #audioRecordingTemplate let-audioRecordingTemplateRef="dialogRef">
  <div class="card dialog-box mt-5">
    <div class="card-header">
      Recording
      @if (recordingTime) {
        <span class="fw-semibold"> {{ recordingTime }}s</span>
      }
    </div>
    @if (recordingStarted) {
      <div
        class="d-flex flex-column gap-5 pt-5 justify-content-between vh-50"
        style="height: 50vh"
      >
        <div class="d-flex justify-content-center">
          <div class="flex-grow-1">
            <canvas id="waveCanvas" class="wave-canvas"> </canvas>
          </div>
          <div class="d-none fw-semibold">{{ recordingTime }}s</div>
        </div>

        @if (speechRecognitionText) {
          <div class="d-flex justify-content-center">
            {{ speechRecognitionText }}
          </div>
        }

        <div class="d-flex align-items-center gap-5 justify-content-evenly">
          <div
            role="button"
            class="d-flex justify-content-center h1"
            (click)="
              stopRecordingAndRemoveAudio(); audioRecordingTemplateRef.close()
            "
          >
            <i class="fa-solid fa-rectangle-xmark text-danger fa-3x"></i>
          </div>

          @if (recordingTime > 0 && !audioSendBtnPressed) {
            <div class="d-flex justify-content-center">
              <div
                role="button"
                (click)="
                  stopRecordingAndSendMessage();
                  audioRecordingTemplateRef.close()
                "
                class="fs-3 h1 border p-3 rounded text-white bg-success text-center"
              >
                Send
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="alert alert-primary my-3">
        <div class="fw-bold">
          Initializing. Please wait.
          <div class="spinner-grow float-end" role="status"></div>
        </div>
      </div>
    }
  </div>
</ng-template>
<ng-template
  #clockInAndOutAdditionalInfoTemplate
  let-clockInAndOutAdditionalInfoTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card p-2">
    <div class="card-header">{{ data?.header }}</div>
    @if (data?.message) {
      <div class="alert">{{ data?.message }}</div>
    }

    @if (data?.needReason) {
      @if (data?.needReason | misc: "shiftTimeRemaining") {
        <div class="alert text-center alert-info">
          You have {{ data?.needReason | misc: "shiftTimeRemaining" }} minutes
          left in your shift.
        </div>
      }
      <div>
        <textarea
          class="form-control"
          type="text"
          [placeholder]="data?.placeholder"
          [(ngModel)]="data.reason"
          rows="3"
        ></textarea>
      </div>
    }

    <div class="d-flex gap-2 pt-4">
      <button
        type="button"
        class="btn btn-dark btn-lg w-100"
        (click)="clockInAndOutAdditionalInfoTemplateRef.close(false)"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary btn-lg w-100"
        [disabled]="!data?.reason && data?.needReason"
        (click)="clockInAndOutAdditionalInfoTemplateRef.close(data)"
      >
        {{ data?.needReason ? "Submit" : "Confirm" }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template
  #nativeAppDownloadTemplate
  let-nativeAppDownloadTemplate="dialogRef"
  let-data
>
  <div class="text-end p-2">
    <button
      class="btn btn-dark btn-sm"
      (click)="nativeAppDownloadTemplate.close()"
    >
      Close
    </button>
  </div>
  <div
    class="d-flex gap-4 flex-column justify-content-center align-items-center"
  >
    <img
      [src]="data?.src"
      alt="QR Code"
      width="400"
      class="mb-0 bg-white p-1 rounded"
    />
    <div class="alert">
      Scan the qr code with your phone to download the app
    </div>
  </div>
</ng-template>
